{
    "RandomiseTitle": "Randomiser le mot de passe",
    "PasswordStrength": "La force du mot de passe :",
    "PasswordStrength_0": "Trop court",
    "PasswordStrength_1": "Très faible",
    "PasswordStrength_2": "Faible",
    "PasswordStrength_3": "Modéré",
    "PasswordStrength_4": "Fort",
    "PasswordStrength_5": "Très fort",
    "NAME": "PasswordTextInput",
    "PasswordRequirements_Title": "Exigences en matière de mot de passe :"
}